import React, { Component } from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { ALREADY_REGISTERED, ANOTHER_REGISTERED } from '../../App';

const messages = defineMessages({
  alreadyRegistered: {
    id: 'alreadyRegistered',
    defaultMessage: 'This device is already registered to your group.'
  },
  anotherRegistered: {
    id: 'anotherRegistered',
    defaultMessage: 'This device is already registered to another group.'
  },
  genericRegistered: {
    id: 'genericRegistered',
    defaultMessage: 'This device is already registered.'
  }
});

class Notification extends Component {
  componentWillMount() {
    let notification;

    switch (this.props.error) {
      case ALREADY_REGISTERED:
        notification = 'alreadyRegistered';
        break;
      case ANOTHER_REGISTERED:
        notification = 'anotherRegistered';
        break;
      default:
        notification = 'genericRegistered';
        break;
    }

    this.props.setNotification(this.props.intl.formatMessage(messages[notification]));
  }

  render() {
    return (<div />);
  }
}

Notification.propTypes = {
  intl: PT.object,
  setNotification: PT.func,
  removeRegistration: PT.func,
  error: PT.string,
  history: PT.object
};

export default injectIntl(Notification);



// WEBPACK FOOTER //
// ./src/components/RegisterFailedNotification/RegisterFailedNotification.js